<template>
  <div class="position-relative" :class="{ 'more-filters': moreFilters }">
    <v-select
      class="rounded-sm"
      :items="categories"
      v-model="categoriesSelecteds"
      :loading="loading.categories"
      label="Categoria"
      name="t"
      background-color="white"
      hide-details
      outlined
      dense
      multiple
    ></v-select>

    <template v-if="moreFilters">
      <v-select
        class="rounded-sm"
        :items="citiesFiltered"
        v-model="citiesSelecteds"
        :loading="loading.cities"
        label="Cidade"
        name="b"
        background-color="white"
        hide-details
        outlined
        dense
      ></v-select>

      <v-autocomplete
        class="rounded-sm"
        :items="districtsFilteredByCity"
        v-model="districtsSelecteds"
        :loading="loading.districts"
        name="d"
        label="Bairro"
        background-color="white"
        no-data-text="Selecione uma Cidade"
        hide-details
        outlined
        dense
        multiple
      ></v-autocomplete>

      <v-text-field
        class="rounded-sm"
        label="Código"
        name="c"
        v-model="referenceSelecteds"
        background-color="white"
        hide-details
        outlined
        dense
      ></v-text-field>

      <div>
        <div class="secondary--text text-body-2 text-center font-weight-bold">
          <span class="font-secondary"> Vagas de garagem </span>
        </div>

        <v-select
          :items="parkingLots"
          v-model="parkingLotsSelecteds"
          placeholder="A partir de"
          name="pl"
          prepend-icon="fas fa-car"
          hide-details
          dense
        ></v-select>
      </div>

      <div>
        <div class="secondary--text text-body-2 text-center font-weight-bold">
          <span class="font-secondary"> Quartos </span>
        </div>
        <v-select
          :items="rooms"
          v-model="roomsSelecteds"
          placeholder="A partir de"
          name="r"
          prepend-icon="fas fa-bed"
          hide-details
          dense
        ></v-select>
      </div>

      <div>
        <div class="d-flex justify-space-between">
          <div class="search-widget-price-range-label mb-n3">
            {{ areaRangeStart + "m²" }}
          </div>

          <div class="secondary--text text-body-2 text-center font-weight-bold">
            <span class="font-secondary">Metragem do Terreno</span>
          </div>

          <div class="search-widget-price-range-label mb-n3">
            {{ areaRangeEnd + "m²" }}
          </div>
        </div>

        <v-range-slider
          class="align-center price-range"
          color="secondary"
          v-model="areaRange"
          :min="areaMin"
          :max="areaMax"
          :step="10"
          hide-details
        ></v-range-slider>
      </div>

      <div>
        <div class="d-flex justify-space-between">
          <div class="search-widget-price-range-label mb-n3">
            {{ buildingRangeStart + "m²" }}
          </div>

          <div class="secondary--text text-body-2 text-center font-weight-bold">
            <span class="font-secondary">Área Construída</span>
          </div>

          <div class="search-widget-price-range-label mb-n3">
            {{ buildingRangeEnd + "m²" }}
          </div>
        </div>

        <v-range-slider
          class="align-center price-range"
          color="secondary"
          v-model="buildingRange"
          :min="buildingMin"
          :max="buildingMax"
          :step="10"
          hide-details
        ></v-range-slider>
      </div>
    </template>

    <div>
      <div class="d-flex justify-space-between">
        <div class="search-widget-price-range-label mb-n3">
          {{ formatPrice(priceRangeStart) }}
        </div>

        <div class="secondary--text text-body-2 text-center font-weight-bold">
          <span class="font-secondary">Faixa de valor</span>
        </div>

        <div class="search-widget-price-range-label mb-n3">
          {{ formatPrice(priceRangeEnd) }}
        </div>
      </div>

      <v-range-slider
        class="align-center price-range"
        color="secondary"
        v-model="priceRange"
        :max="priceMax"
        :min="priceMin"
        :step="business === 1 ? 100 : 10000"
        hide-details
      ></v-range-slider>
    </div>

    <div class="d-flex justify-center plus-filters-btn">
      <v-btn
        @click="moreFilters = !moreFilters"
        class="rounded-sm font-weight-medium"
        color="primary"
        depressed
        small
        dark
      >
        <span>{{ !moreFilters ? "Mais" : "Menos" }} Filtros</span>

        <v-icon right small>
          fas fa-search-{{ !moreFilters ? "plus" : "minus" }}
        </v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { formatPrice } from "../../utils/formatPrice";
import { formatToURL } from "../../utils/formatToURL";

export default {
  props: {
    business: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    showFilters: undefined,
    loading: {
      categories: true,
      cities: true,
      districts: false,
    },
    categories: [],
    cities: [],
    citiesFiltered: [],
    districts: [],
    districtsFilteredByCity: [],
  }),
  created() {
    this.getCategories();
    this.getCities();
    this.getDistricts();

    this.checkSelectedCity();
  },
  computed: {
    moreFilters: {
      get() {
        return this.showFilters;
      },
      set(v) {
        this.showFilters = v;
      },
    },
    filters() {
      return this.$route.query;
    },
    categoriesSelecteds: {
      get() {
        const t = this.filters.t;
        return t && t.split(",").map((v) => parseInt(v));
      },
      set(v) {
        const search = new URLSearchParams(location.search);
        search.set("t", v.join(","));

        this.$router.push("?" + search.toString());
      },
    },
    referenceSelecteds: {
      get() {
        return this.filters.c;
      },
      set(v) {
        const search = new URLSearchParams(location.search);
        search.set("c", v);

        this.$router.push("?" + search.toString());
      },
    },
    citiesSelecteds: {
      get() {
        return this.filters.b;
      },
      set(v) {
        const search = new URLSearchParams(location.search);

        if (v) search.set("b", v);
        else search.delete("b");

        search.delete("d");

        this.$router.push("?" + search.toString());
      },
    },
    districtsSelecteds: {
      get() {
        const d = this.filters.d;
        return d && d.split(",").map((v) => parseInt(v));
      },
      set(v) {
        const search = new URLSearchParams(location.search);
        search.set("d", v.join(","));

        this.$router.push("?" + search.toString());
      },
    },
    parkingLotsSelecteds: {
      get() {
        return this.filters.pl;
      },
      set(v) {
        const search = new URLSearchParams(location.search);
        search.set("pl", v);

        this.$router.push("?" + search.toString());
      },
    },
    roomsSelecteds: {
      get() {
        return this.filters.r;
      },
      set(v) {
        const search = new URLSearchParams(location.search);
        search.set("r", v);

        this.$router.push("?" + search.toString());
      },
    },
    terrainAreaSelecteds: {
      get() {
        return this.filters.ta;
      },
      set(v) {
        const search = new URLSearchParams(location.search);
        search.set("ta", v);

        this.$router.push("?" + search.toString());
      },
    },
    buildingAreaSelecteds: {
      get() {
        return this.filters.ba;
      },
      set(v) {
        const search = new URLSearchParams(location.search);
        search.set("ba", v);

        this.$router.push("?" + search.toString());
      },
    },
    parkingLots() {
      return [
        { text: "1", value: "1" },
        { text: "2", value: "2" },
        { text: "3", value: "3" },
        { text: "4", value: "4" },
        { text: "5", value: "5" },
      ];
    },
    rooms() {
      return [
        { text: "1", value: "1" },
        { text: "2", value: "2" },
        { text: "3", value: "3" },
        { text: "4", value: "4" },
        { text: "5", value: "5" },
      ];
    },
    areaMax() {
      return 1200;
    },
    areaMin() {
      return 0;
    },
    areaRange: {
      get() {
        return [this.areaRangeStart, this.areaRangeEnd];
      },
      set(v) {
        this.areaRangeStart = v[0];
        this.areaRangeEnd = v[1];
      },
    },
    areaRangeStart: {
      get() {
        return this.$route.query.amin || this.areaMin;
      },
      set(v) {
        const search = new URLSearchParams(location.search);
        const amin = search.get("amin");

        if (amin == v) return false;

        search.set("amin", v);

        this.$router.push("?" + search.toString());
      },
    },
    areaRangeEnd: {
      get() {
        return this.$route.query.amax || this.areaMax;
      },
      set(v) {
        const search = new URLSearchParams(location.search);
        const amax = search.get("amax");

        if (amax == v) return false;

        search.set("amax", v);

        this.$router.push("?" + search.toString());
      },
    },
    buildingMax() {
      return 1000;
    },
    buildingMin() {
      return 0;
    },
    buildingRange: {
      get() {
        return [this.buildingRangeStart, this.buildingRangeEnd];
      },
      set(v) {
        this.buildingRangeStart = v[0];
        this.buildingRangeEnd = v[1];
      },
    },
    buildingRangeStart: {
      get() {
        return this.$route.query.bmin || this.buildingMin;
      },
      set(v) {
        const search = new URLSearchParams(location.search);
        const bmin = search.get("bmin");

        if (bmin == v) return false;

        search.set("bmin", v);

        this.$router.push("?" + search.toString());
      },
    },
    buildingRangeEnd: {
      get() {
        return this.$route.query.bmax || this.buildingMax;
      },
      set(v) {
        const search = new URLSearchParams(location.search);
        const bmax = search.get("bmax");

        if (bmax == v) return false;

        search.set("bmax", v);

        this.$router.push("?" + search.toString());
      },
    },
    priceMax() {
      return this.business === 1 ? 15000 : 5000000;
    },
    priceMin() {
      return 0;
    },
    priceRange: {
      get() {
        return [this.priceRangeStart, this.priceRangeEnd];
      },
      set(v) {
        this.priceRangeStart = v[0];
        this.priceRangeEnd = v[1];
      },
    },
    priceRangeStart: {
      get() {
        return this.$route.query.pmin || this.priceMin;
      },
      set(v) {
        const search = new URLSearchParams(location.search);
        const pmin = search.get("pmin");

        if (pmin == v) return false;

        search.set("pmin", v);

        this.$router.push("?" + search.toString());
      },
    },
    priceRangeEnd: {
      get() {
        return this.$route.query.pmax || this.priceMax;
      },
      set(v) {
        const search = new URLSearchParams(location.search);
        const pmax = search.get("pmax");

        if (pmax == v) return false;

        search.set("pmax", v);

        this.$router.push("?" + search.toString());
      },
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    getCategories() {
      this.loading.categories = true;

      const params = {
        business: this.business,
      };

      this.$rest("propertiesCategories")
        .get({ params })
        .then((data) => {
          this.categories = data
            .map(({ id, title }) => ({
              text: title,
              value: id,
            }))
            .sort((a, b) => a.text.localeCompare(b.text));
        })
        .then(() => (this.loading.categories = false));
    },
    getCities() {
      this.loading.cities = true;

      const params = {
        business: this.business,
      };

      this.$rest("propertiesCities")
        .get({ params })
        .then((data) => {
          this.cities = data;
          const cities = { text: "Todas as Cidades", value: null };
          this.citiesFiltered = [
            cities,
            ...data
              .map(({ id, title }) => ({
                text: title,
                value: String(id),
              }))
              .sort((a, b) => a.text.localeCompare(b.text)),
          ];
        })
        .then(() => (this.loading.cities = false));
    },
    getDistricts() {
      const params = {
        business: this.business,
      };

      this.$rest("propertiesDistricts")
        .get({ params })
        .then((data) => {
          this.districts = data;
        });
    },
    formatPrice,
    checkSelectedCity() {
      if (this.citiesSelecteds) {
        const citySelected = this.cities.find(
          ({ id }) => this.citiesSelecteds == id
        );

        this.loading.districts = true;

        this.districtsFilteredByCity = this.districts
          .filter(
            ({ city, state }) =>
              `${formatToURL(city)}-${formatToURL(state)}` ===
              `${formatToURL(citySelected.title)}-${formatToURL(
                citySelected.state
              )}`
          )
          .map(({ id, title }) => ({
            text: title,
            value: id,
          }))
          .sort((a, b) => a.text.localeCompare(b.text));

        this.loading.districts = false;
      } else this.districtsFilteredByCity = [];
    },
  },
  watch: {
    priceMax(v) {
      if (!this.priceRangeEnd) this.priceRangeEnd = v;
    },
    priceMin(v) {
      if (!this.priceRangeStart) this.priceRangeStart = v;
    },
    citiesSelecteds() {
      this.checkSelectedCity();
    },
    districts() {
      this.checkSelectedCity();
    },
    business() {
      this.getCategories();
      this.getCities();
      this.getDistricts();
    },
  },
};
</script>

<style lang="scss" scoped>
.price-range::v-deep {
  .v-slider {
    .v-slider__track-background {
      background-color: var(--v-secondary-lighten2) !important;
    }
  }
}

.plus-filters-btn {
  width: 100%;
  position: absolute;
  bottom: -14px;
}
</style>
